module.exports = __webpack_public_path__ + "media/images/icons/icon-arrow-prev-alt-b08ac4f5a0aa17f701d45d7452d73dca.svg";